module.exports = __webpack_public_path__ + "media/notification_simple-01.27fbe8a5.wav";